// @ts-nocheck

import React, { useCallback } from 'react';
import styled, { css } from 'styled-components';

import imagePath from '../../../../assets/img/grids/gridIrma.png';
import { Target } from '../../../../client';
import Link from '../../../../components/Link';
import LoadingSpinner from '../../../../components/LoadingSpinner';
import ModalFooter from '../../../../components/ModalFooter';
import { __ } from '../../../../i18n/l10n';
import GridsBasketButtonContainer from '../../containers/basket/GridsBasketButtonContainer';
import GridsBasketContentContainer from '../../containers/basket/GridsBasketContentContainer';
import GridsValidatedViewContainer from '../../containers/basket/GridsValidatedViewContainer';
import GridsAuthorContainer from '../../containers/GridsAuthorContainer';
import GridsInfoBasketContainer from '../../containers/GridsInfoBasketContainer';
import GridsPrizepoolContainer from '../../containers/GridsPrizepoolContainer';
import GridsPublicGridButtonContainer from '../../containers/public/GridsPublicGridButtonContainer';
import Primary from '../buttons/Primary';
import EmptyView from '../EmptyView';
import PoolTitle from '../pool/PoolTitle';

const Wrap = styled.div`
  padding: ${Target.__MOBILE__ ? '0 1em 1em' : 0};
`;

const Error = styled.p`
  color: ${({ theme }) => (Target.__MOBILE__ ? theme.grids.colors.redlight : '#000')};
`;

const ButtonBack = styled(Primary)`
  && {
    margin: 1em;
  }
`;

const GridBloc = styled.div`
  ${({ theme }) => theme.grids.desktopBloc}
  padding: 1em 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const WhiteGridBloc = styled(GridBloc)`
  background: #fff;
  margin-bottom: 1em;
`;

const StyledGridsPrizepoolContainer = styled(GridsPrizepoolContainer)`
  margin: 1em 0;
`;

const StyledGridsBasketButtonContainer = styled(GridsBasketButtonContainer)`
  padding: 0.4em;
  padding-bottom: 0.4em;
  padding-bottom: calc(0.4em + constant(safe-area-inset-bottom));
  padding-bottom: calc(0.4em + env(safe-area-inset-bottom));
`;

const StyledPoolTitle = styled(PoolTitle)`
  ${({ theme }) => css`
    color: ${theme.grids.colors.black};
    margin: 0;
    svg {
      stroke: ${theme.grids.colors.black};
    }
  `}
`;

const SubTitle = styled.p`
  color: ${({ theme }) => theme.grids.colors.middlegrey2};
  margin: 0 0 1em 0;
  text-align: center;
  text-transform: uppercase;
  font-size: 0.9em;
  font-family: BettingPoliticaBold, sans-serif;
`;

type GridsBasketViewProps = {
  poolId: number;
  isAvailable: boolean;
  isValidated: boolean;
  errorLabel: string;
  gridReference: string;
  isFunding: boolean;
  isEmpty: boolean;
  isSubmitting: boolean;
  poolNumber: number;
};

const SubmitView = () => (
  <EmptyView isDisabledFit={!Target.__MOBILE__}>
    <LoadingSpinner />
  </EmptyView>
);

const Empty = () => (
  <EmptyView imgPath={imagePath}>
    <Link to="/grilles">
      <ButtonBack>{__('Back to the grid of the day')}</ButtonBack>
    </Link>
  </EmptyView>
);

const GridsBasketView = ({
  poolId,
  isAvailable,
  isValidated,
  errorLabel,
  gridReference,
  isFunding,
  isEmpty,
  isSubmitting,
  poolNumber,
}: GridsBasketViewProps) => {
  const renderFooter = useCallback(
    () => <StyledGridsBasketButtonContainer gridReference={gridReference} />,
    [gridReference],
  );

  const renderEmpty = useCallback(() => (Target.__MOBILE__ ? <Empty /> : null), []);

  if (isEmpty) {
    return renderEmpty();
  }

  if (isSubmitting) {
    return Target.__MOBILE__ ? (
      <SubmitView />
    ) : (
      <GridBloc>
        <SubmitView />
      </GridBloc>
    );
  }

  return isAvailable ? (
    <Wrap>
      {isValidated && (
        <>
          {Target.__MOBILE__ ? (
            <GridsValidatedViewContainer />
          ) : (
            <WhiteGridBloc>
              <GridsValidatedViewContainer />
            </WhiteGridBloc>
          )}
        </>
      )}
      {!isValidated && (
        <>
          {Target.__MOBILE__ && isFunding && (
            <>
              <StyledPoolTitle poolNumber={poolNumber} withPicto />
              <SubTitle>{__('Public grids')}</SubTitle>
              <GridsAuthorContainer gridReference={gridReference} isPublicGrid isBasket />
            </>
          )}
          {Target.__MOBILE__ && !isFunding && <GridsInfoBasketContainer />}
          {!Target.__MOBILE__ && !isFunding && (
            <>
              <GridBloc>
                <GridsPublicGridButtonContainer poolId={poolId} />
              </GridBloc>
              <StyledGridsPrizepoolContainer poolId={poolId} />
            </>
          )}
        </>
      )}
      {!isValidated && <GridsBasketContentContainer />}
      {Target.__MOBILE__ && <ModalFooter render={renderFooter} />}
      {!isValidated && errorLabel && <Error>{errorLabel}</Error>}
    </Wrap>
  ) : (
    renderEmpty()
  );
};

export default GridsBasketView;
